// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","logo":"Header_logo__3_SJs"};